import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  MaterialGradeSchema,
  OrderTypeSchema,
  PrioritySchema,
  QuoteRequestSchema,
  QuoteRequestStatusSchema,
  ShippingPrioritySchema,
} from "../types";

const c = initContract();

export const publicContract = c.router({
  createFromAnonymous: {
    method: "POST",
    path: "/public/:id/quote-requests",
    query: z.object({
      userId: z.string().optional(),
    }),
    body: z.object({
      reference: z.string().optional(),
      clientReference: z.string().optional(),
      mailId: z.string().optional(),
      date: z.string().optional(),
      dueDate: z.string().optional(),
      orderType: OrderTypeSchema.nullable().optional(),
      targetPrice: z.number().optional(),
      nCompaniesRequested: z.number().optional(),
      foreignCompaniesRequested: z.boolean().optional(),
      alreadyManufacturedParts: z.boolean().optional(),
      certificationNeeded: z.string().optional(),
      quoteSentAt: z.coerce.date().optional(),
      isFavorite: z.boolean().optional(),
      shippingPriority: ShippingPrioritySchema.optional(),
      priority: PrioritySchema.nullable().optional(),
      status: QuoteRequestStatusSchema.optional(),
      client: z
        .object({
          id: z.string().uuid(),
          name: z.string().optional(),
        })
        .nullable()
        .optional(),
      contact: z
        .object({
          id: z.string().uuid().optional(),
          firstName: z.string().optional(),
          lastName: z.string().optional(),
          email: z.string().email().optional(),
          phone: z.string().optional(),
        })
        .nullable()
        .optional(),
      shippingAddress: z
        .object({
          id: z.string().uuid().optional(),
          street: z.string().optional(),
          city: z.string().optional(),
          zipCode: z.string().optional(),
        })
        .optional(),
      billingAddress: z
        .object({
          id: z.string().uuid().optional(),
          street: z.string().optional(),
          city: z.string().optional(),
          zipCode: z.string().optional(),
        })
        .optional(),
      quoteRequestLines: z
        .object({
          comment: z.string().optional(),
          quantity: z.number(),
          part: z.object({
            name: z.string(),
            materialGrade: MaterialGradeSchema.optional(),
            tolerance: z.string().optional(),
            clientReference: z.string().optional(),
            internalReference: z.string().optional(),
            files: z
              .object({
                name: z.string(),
                url: z.string(),
              })
              .array()
              .optional(),
          }),
        })
        .array(),
      clientNote: z.string().optional(),
    }),
    responses: {
      201: QuoteRequestSchema,
    },
  },
});
